import { createListenerMiddleware } from '@reduxjs/toolkit';
import type { RootState } from '@forvalter/store';
import { localStorageReferences } from './config';

export const contractRegistrationListenerMiddleware =
    createListenerMiddleware();

const startAppListening = contractRegistrationListenerMiddleware.startListening;

startAppListening({
    predicate: (action, currentState: RootState, previousState: RootState) => {
        const current = currentState.contractRegistration;
        const previous = previousState.contractRegistration;

        return (
            current.status !== previous.status ||
            current.fromDate !== previous.fromDate ||
            current.maxResult !== previous.maxResult ||
            current.selectedKunde !== previous.selectedKunde
        );
    },
    effect: (action, { getState }) => {
        const { status, fromDate, maxResult, selectedKunde } = (
            getState() as RootState
        ).contractRegistration;
        localStorage.setItem(
            localStorageReferences.CONTRACT_REGISTRATION_FILTERS,
            JSON.stringify({
                status,
                fromDate,
                maxResult,
                selectedKunde,
            }),
        );
    },
});
